import { Component, OnInit, OnDestroy, AfterViewInit } from '@angular/core';
import { DesignService } from '../../../services/design.service';
import { SubscriptionService } from '../../../shared/services/subscription.service';
import { DesigncategoryModel } from '../../../models/DesignCategoryModel';
import { Router, ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs/Subscription';
import { Utilities } from '../../../Utilities';
import { CommonService } from '../../../shared/services/common.service';
import { Observable } from 'rxjs/Observable';
import { custom } from 'devextreme/ui/dialog';

@Component({
  selector: 'app-design',
  templateUrl: './design.component.html',
  styleUrls: ['./design.component.css']
})
export class DesignComponent implements OnInit, OnDestroy, AfterViewInit {
  public categoriesList: DesigncategoryModel[] = [];
  public paramId: string;
  private subscriptions: Subscription[] = [];
  private customDialog: any;
  constructor(public designService: DesignService,
    public subscriptionService: SubscriptionService,
    public commonService: CommonService,
    public router: Router, public route: ActivatedRoute) { }

  ngOnInit() {
    this.subscriptions.push(this.route.params.subscribe(param => this.paramId = param["buyerWishListChangeOrderId"].toLowerCase()));
  }

  ngAfterViewInit() {
    this.subscriptions.push(this.subscriptionService.IsDesignFeatureEnabled$.subscribe(isDesignEnabled => {
      if (isDesignEnabled != null) {
        if (isDesignEnabled === false) {
          this.router.navigate(['/dashboard/']);
        } else {
          if (!this.subscriptionService.designDisclosureMessage) {
            this.commonService.getDisclosureMessageFromConfig().subscribe(x => {
              this.subscriptionService.designDisclosureMessage = x.Value;
              this.setCategoties();
            });
          } else {
            this.setCategoties();
          }
        }
      }
    }));
  }

  private setCategoties() {
    this.customDialog = custom({
      title: "Disclosure",
      message: this.subscriptionService.designDisclosureMessage,
      buttons: [{
        text: "Yes", onClick: () => {
          this.subscriptions.push(this.designService.categoriesList.subscribe(list => {
            if (list) {
              this.categoriesList = list;
            }
          }));
        }
      }, {
        text: "No", onClick: () => {
          this.customDialog.hide();
          this.router.navigate(['/design/']);
        }
      },],
      showTitle: true
    });
    this.customDialog.show();
  }

  public onImageClick(event: any) {
    let selectedItem: DesigncategoryModel = event.itemData;
    this.router.navigate(['/design/designSubCategories/' + selectedItem.SectionId + '/buyerWishListChangeOrderId/' + this.paramId]);
  }

  public onBackClick($event: any) {
    this.router.navigate(['/design/']);
  }

  ngOnDestroy() {
    if (this.customDialog) {
      this.customDialog.hide();
    }
    this.subscriptions.forEach(x => x.unsubscribe());
  }

}



// WEBPACK FOOTER //
// ./src/app/modules/dashboard/design/design.component.ts